//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import xButton from '@/components/common/x-button.vue'
import Xcell from '@/components/common/x-cell'
import ProtocolList from "@/components/instructionProtocol/list"   
import { staticType } from "./config"    

export default {
    components: { xButton, Xcell, ProtocolList },
    name:'NewProtocol',
    data(){
        return{
            itemList:[],
            itemTitle:'',
            modeShow:false
        }
    },
    props:{
        materielMap:{ //协议内容
            type: Array,
            default() { return  [] } 
        },
        staticName:{ //埋点配置信息
            type: String,
            default() { return 'proinfo' } 
        },
        descriptions:{ //协议内容
            type: Array,
            default() { return  []} 
        },
    },
    watch: {
        modeShow(val) {
            if (val) {
                // 弹窗弹出埋点
                staticType[this.staticName].showBox()
            }
        }
    },
    mounted(){
        this.$refs.fileList.currentValue=false
    },
    methods:{
         // 展示弹框
        treatyClick(item){
            this.$emit('treatyClick', 'modal');
            console.log('treatItem',item)
            if(item.materielList.length > 1){
                this.$refs.fileList.currentValue=true
                this.itemTitle = item.fileCategoryDesc
                this.itemList = item.materielList
            }else{
                this.cellClick(item.materielList[0])
            }
        },
        cellClick(item){
            console.log('cellItem',item)
            if(item.shortUrl){
                const url = `${encodeURIComponent(
                    item.shortUrl
                )}`;
                this.$router.push({
                    path: "/webpdf",
                    query: {
                        file: url
                    },
                    flag: "postdisable",
                });
            }else{
                this.$toast("未获取到pdf地址");
            }
             this.$refs.fileList.currentValue=false
        },
        btnClick(){
            staticType[this.staticName].check()
            this.modeShow=false
            this.$emit('submitClick', true)
        },
        // 关闭弹窗
        input(){
            this.modeShow=false
        }
    }
}
